import { Endpoints } from '@/api/ApiEndpoints';

const Leagues = {
	Plural: 'Leagues',
	Single: 'League',
	ModalForm: true,
	DefaultSorting: 'Name',
	DefaultSortingType: 'desc',
	Columns: [
		{
			name: '',
			label: '#',
			type: 'counter',
		},
		{
			name: 'id',
			dbName: 'id',
			label: 'ID',
			sortable: true,
			required: true,
			type: 'text',
		},
		{
			name: 'name',
			dbName: 'Name',
			label: 'Name',
			sortable: true,
			required: true,
			type: 'text',
		},
		{
			name: 'country',
			label: 'Countries',
			required: true,
			type: 'array',
			objectAttr: {
				name: 'name',
				linkedAttr: 'id',
				link: '/Country/',
			},
			format: (item) => {
				let htmlToReturn='';
				htmlToReturn +='<div>'+item.country.name+'</div>'
					
				return htmlToReturn;
			}
		},
		
	],
	Filters: [
		{
			name: 'Countries',
			label: 'Country',
			nameToRequest: 'CountryId',
			endpoint: Endpoints.COUNTRIES_FOR_FILTERS,
			type: 'groupedSelect',
			attributes: {
				name: 'name',
				linkedAttr: 'id',
			},
			mapping: (countriesFromResponse) => {
				return countriesFromResponse;
			},
		},
	],
	PrimaryKey: 'id',
	Actions: {
		addLink: '/leagues/add/',
		editLink: '/leagues/edit/',
		
	},
};

export default Leagues;
